import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { NoDataCard } from 'legacyComponents/cards/types/noData';
import { Tab } from 'legacyComponents/styled/lib';
import { ContributionCard } from 'legacyComponents/cards/types/contribution';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { Section } from 'legacyComponents/layout/section';

import { ContributionConnManager } from 'apps/repository/connManager';
import { themes } from 'styles/themes/wikifactoryNew';
import { type WithNamespaces, withNamespaces } from 'react-i18next';
import type { ProjectApp } from 'apps/project/app';

interface PropsI extends WithNamespaces {
  project: ProjectApp;
  manager: any;
  app: any;
}

export const HistorySection = withNamespaces()(
  observer((props: PropsI) => {
    const { project, manager, app, t } = props;

    const { cwdFiles } = app || {};

    const [contributionsConn] = useState(() => {
      return new ContributionConnManager(null, {
        projectId: project.id,
      });
    });

    useEffect(() => {
      contributionsConn?.loadMore();
    }, []);

    useEffect(() => {
      manager.contributionsConn = contributionsConn;
    }, [contributionsConn]);

    const contributions = contributionsConn?.arrayApp;

    if (
      !contributionsConn ||
      (!contributionsConn.loading && contributionsConn.totalCount === 0)
    ) {
      return (
        <NoDataCard
          type='contributions'
          owner={project.inSpace.whichTypes.includes('Contribution')}
        />
      );
    }

    return (
      <>
        <div id='history-header' />
        <Section
          title={t('History')}
          subTitle={`(${contributionsConn.totalCount})`}
          last
          headerWrapperStyle={{
            borderBottom: `1px solid ${themes.color.wfGrey100}`,
            paddingBottom: 18,
          }}
        >
          <div>
            <Tab noShadow>
              <CardSection
                title=''
                cardApp={contributions}
                CardComponent={ContributionCard}
                noMarginTop
                cwdFiles={cwdFiles}
              />
            </Tab>
          </div>
        </Section>
      </>
    );
  }),
);

HistorySection.propTypes = {
  app: PropTypes.object,
  project: PropTypes.object,
  manager: PropTypes.object,
};
